import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { Alert } from "@domestika-dev/prudencio/dist/atoms/Alert";
import { Icon } from "@domestika-dev/prudencio/dist/atoms/Icon";
import { InfoCircle } from "@domestika-dev/prudencio/dist/atoms/Icons";
import { Text } from "@domestika-dev/prudencio/dist/atoms/Typography/Typography";
import { Flex, GridItem } from "@domestika-dev/prudencio/dist/atoms/Layout";

export const LiveSessionScheduleEmailAlert = ({ numberOfStudents }) => (
  <GridItem gridRow={7} gridColumn="1 / span 8" marginTop={6}>
    <Alert type="warning" isClosable={false}>
      <Flex justifyContent="flex-start" alignItems="center">
        <Icon size="medium" marginRight={4}>
          <InfoCircle />
        </Icon>
        <Text size="micro">
          <FormattedMessage
            id="live_sessions.schedule_new.email_alert"
            values={{ number: numberOfStudents }}
          />
        </Text>
      </Flex>
    </Alert>
  </GridItem>
);

LiveSessionScheduleEmailAlert.propTypes = {
  numberOfStudents: PropTypes.number,
};

LiveSessionScheduleEmailAlert.defaultProps = {
  numberOfStudents: 0,
};

export default LiveSessionScheduleEmailAlert;
